module.exports = __webpack_public_path__ + "static/img/notice_title_bg.fcf86229.fcf8622.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/yuejuan-ui/lib/img/notice_title_bg.fcf86229.svg
// module id = eoqO
// module chunks = 129